/**
 * Footer.jsx
 * components/user/Footer.jsx
 */

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      style={{
        background: "#060D1A",
        borderTop:  "1px solid rgba(255,255,255,0.06)",
        fontFamily: "'Nunito','Segoe UI',sans-serif",
        padding:    "28px 1.5rem",
      }}
    >
      <div
        style={{
          maxWidth: 1100,
          margin:   "0 auto",
          display:  "flex",
          alignItems:    "center",
          justifyContent:"space-between",
          flexWrap:      "wrap",
          gap:           16,
        }}
      >
        {/* Logo */}
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{
            width: 32, height: 32, borderRadius: 8,
            background: "rgba(29,158,117,0.15)",
            border: "1px solid rgba(29,158,117,0.3)",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C9 2 6.5 4.2 6.5 7C6.5 8.6 7.1 9.7 7.1 11.2C7.1 13.8 6 16.2 6 18.6C6 20.6 7 22 8.5 22C10 22 10.5 20 12 20C13.5 20 14 22 15.5 22C17 22 18 20.6 18 18.6C18 16.2 16.9 13.8 16.9 11.2C16.9 9.7 17.5 8.6 17.5 7C17.5 4.2 15 2 12 2Z" fill="#1D9E75"/>
              <path d="M9.5 7.5C9.5 6 10.6 5 12 5C13.4 5 14.5 6 14.5 7.5" stroke="white" strokeWidth="1.4" strokeLinecap="round"/>
            </svg>
          </div>
          <div>
            <span style={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>OM Dental</span>
            <div style={{ fontSize: 10, color: "rgba(255,255,255,.35)", letterSpacing: "1px" }}>Ahmedabad, Gujarat</div>
          </div>
        </div>

        {/* Copyright */}
        <p style={{ margin: 0, fontSize: 12, color: "rgba(255,255,255,.35)", textAlign: "center" }}>
          © {year} OM Dental Clinic. All rights reserved.
        </p>

        {/* Tagline */}
        <p style={{ margin: 0, fontSize: 12, color: "rgba(255,255,255,.35)" }}>
          Made with 🦷 for healthier smiles
        </p>
      </div>
    </footer>
  );
}